import firebase from 'firebase'
import store, { Actions } from '../store'
import VueRouter from 'vue-router';
import { CompanyTypeEnum, UserRoleEnum, PriceListCollection } from 'serverless-firestore';
import { home as vendorHome } from '@/views/Vendor/NavBar'
import { home as restaurantHome, vendors as vendorsList } from '@/views/Restaurant/NavBar'
import { home as adminHome } from '@/views/Admin/Navbar'
import { getHome } from '@/services/navigation.service'

export default class LoginService {
  static async loadUserAndRoute(
    firebase: Promise<firebase.app.App>,
    credentials: firebase.auth.UserCredential,
    router: VueRouter
  ) {
    const loggedInPromise = new Promise((res, rej) => {
      let unsub: () => void
      unsub = store.subscribeAction((action) => {
        if (action.type === Actions.SET_LOGIN && action.payload) {
          unsub()
          res()
        }
      })
    })

    const token = credentials && credentials.user
      ? ( await credentials.user.getIdTokenResult() ).claims
      : null

    await loggedInPromise

    let home
    if (token) {
      home = getHome(token.company_type)

      if (token.company_type === CompanyTypeEnum.RESTAURANT) {
        let redirectToVendors = false

        const companies = store.state.companies
        if (
          companies
          && [
            UserRoleEnum.MANAGER,
            UserRoleEnum.CHEF,
            UserRoleEnum.GENERAL_MANAGER
          ].includes(companies[token.company_id].userRoles[token.user_id])
        ) {
          const firestore: firebase.firestore.Firestore = ( await firebase ).firestore()
          const priceListCollection = new PriceListCollection(firestore)
          const priceLists = await priceListCollection.listPriceListsByCompanyId(
            token.company_id,
            CompanyTypeEnum.RESTAURANT
          )
          redirectToVendors = !priceLists.length
        }

        home = redirectToVendors ? vendorsList : restaurantHome
      }
    } else {
      home = getHome()
    }

    const route = router.currentRoute

    if (route.query.redirect) {
      await router.push({ path: route.query.redirect as string })
    }
    else {
      await router.push({ name: home })
    }
  }
}
